module.exports = __webpack_public_path__ + "static/media/spring-min.14e4144f.jpeg";